import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent } from "vue"

import { computed, ref } from "vue";
import { MemberEntitySchema, ProjectSchema } from "@/types";
import {
  getProjectApiStore,
  getVersionApiStore,
  identifierSaveStore,
  permissionStore,
  projectStore,
} from "@/hooks";
import { FlexBox, IconButton, ListItem, TextButton } from "@/components/common";
import { InviteMemberModal } from "@/components/members";


/**
 Displays the current project, and allows it to be changed.
 */
const __default__ = {
  name: "ProjectSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const projectInviteId = ref<string>();

const entity = computed(
  () =>
    ({
      entityId: projectInviteId.value,
      entityType: "PROJECT",
    }) as MemberEntitySchema
);

/**
 * Reloads the project list and resets any selected project.
 */
function handleReload() {
  projectInviteId.value = undefined;

  getProjectApiStore.handleLoadProjects();
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(getVersionApiStore).currentProject,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(getVersionApiStore).currentProject) = $event)),
    standout: "",
    "bg-color": "transparent",
    class: "nav-breadcrumb",
    label: "Project",
    options: _unref(projectStore).allProjects,
    loading: _unref(getVersionApiStore).loadLoading,
    "option-value": "projectId",
    "option-label": "name",
    onPopupShow: handleReload
  }, {
    option: _withCtx(({ opt, itemProps }: { opt: ProjectSchema }) => [
      _createVNode(_unref(ListItem), _mergeProps(itemProps, {
        title: opt.name,
        "data-cy-name": opt.name
      }), {
        actions: _withCtx(() => [
          _createVNode(_unref(FlexBox), { justify: "end" }, {
            default: _withCtx(() => [
              (_unref(permissionStore).isAllowed('project.edit_members', opt))
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 0,
                    small: "",
                    tooltip: `Invite to ${opt.name}`,
                    icon: "member-add",
                    "data-cy": "button-project-invite",
                    onClick: ($event: any) => (projectInviteId.value = opt.projectId)
                  }, null, 8, ["tooltip", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(permissionStore).isAllowed('project.edit', opt))
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 1,
                    small: "",
                    tooltip: `Edit ${opt.name}`,
                    icon: "edit",
                    "data-cy": "button-project-edit",
                    onClick: ($event: any) => (_unref(identifierSaveStore).selectIdentifier(opt, 'save'))
                  }, null, 8, ["tooltip", "onClick"]))
                : _createCommentVNode("", true),
              (_unref(permissionStore).isAllowed('project.delete', opt))
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 2,
                    small: "",
                    tooltip: `Delete ${opt.name}`,
                    icon: "delete",
                    "data-cy": "button-project-delete",
                    onClick: ($event: any) => (_unref(identifierSaveStore).selectIdentifier(opt, 'delete'))
                  }, null, 8, ["tooltip", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040, ["title", "data-cy-name"])
    ]),
    "after-options": _withCtx(() => [
      (_unref(permissionStore).isAllowed('safa.view'))
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            block: "",
            label: "Add Project",
            icon: "add",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(identifierSaveStore).selectIdentifier(undefined, 'save')))
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(InviteMemberModal), {
        open: !!projectInviteId.value,
        entity: entity.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (projectInviteId.value = undefined)),
        onSubmit: _cache[2] || (_cache[2] = ($event: any) => (projectInviteId.value = undefined))
      }, null, 8, ["open", "entity"])
    ]),
    _: 1
  }, 8, ["modelValue", "options", "loading"]))
}
}

})